import classNames from 'classnames';

import { CoreGlobalNavigationFooterData } from 'src/types/components';

import TextCTA from 'components/BaseHelpers/TextCTA';

import styles from './PrimaryNav.module.scss';

export type PrimaryNavProps = {
  navigationItems: CoreGlobalNavigationFooterData['fields']['primaryNav'];
  className?: string;
};

const PrimaryNav = ({ navigationItems, className }: PrimaryNavProps): JSX.Element | null => {
  if (navigationItems.length === 0) return null;

  return (
    <ul className={classNames(styles.list, className)} aria-label="Primary navigation">
      {navigationItems.map((item, index) => {
        return (
          <li className={styles.item} key={`footer-nav-${index}`}>
            <TextCTA iconVariant="yellow" tag="a" className={styles.link} {...item} />
          </li>
        );
      })}
    </ul>
  );
};

export default PrimaryNav;
